<template>
  <v-card>
    <v-toolbar extended>
      <v-card-title>
        <T key="3" v-if="is_new">Добавление интервала</T>
        <T key="4" v-else>Редактирование интервала</T> 
      </v-card-title>
      <template v-slot:extension>
        <v-tabs extended v-model="tab">
          <v-tab key="DAYOFWEEK"><T>Дни недели</T></v-tab>
          <v-tab key="DATERANGE"><T>Исключения</T></v-tab>
        </v-tabs>
      </template>

    </v-toolbar>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card-text>
          <div class="d-flex justify-space-between align-center">
            <div v-for="(d, idx) in weekdays" :key="idx" class="d-flex flex-column justify-center align-center px-3" style="cursor: pointer">
              <h3>{{d}}</h3>
              <div><CheckBox :value="value.day_of_week.includes(idx)" @input="v => onDayOfWeek(idx, v)"/></div>
            </div>
          </div>
        </v-card-text>
      </v-tab-item>
      <v-tab-item>
        <v-card-text>
            <v-menu
              v-model = "date_menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="dates_display"
                  :label="$t('Диапозон дат')"
                  dense
                  filled
                  outlined
                  hide-details
                  append-icon="mdi-calendar"
                  readonly
                  class="mb-4"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <div class="date_pickers px-4">
                  <v-checkbox
                    style="width:280px;"
                    v-model="isRange"
                    hide-details
                    :label="$t('Вы хотите выбрать диапозон дат?')"
                  ></v-checkbox>
                  <v-date-picker
                    color="primary"
                    :locale="$store.getters.locale_metadata.Language.replace('_', '-')"
                    v-model="date_from"
                    :events = "interval_dates"
                    :event-color="interval_classes"
                    no-title
                    show-adjacent-months
                    :weekday-format="weekdayFormat"
                    first-day-of-week="1"
                    dense
                  >
                  </v-date-picker>
                  <v-slide-x-transition mode="out-in" appear>
                    <v-date-picker
                      v-if="isRange"
                      color="primary"
                      :locale="$store.getters.locale_metadata.Language.replace('_', '-')"
                      v-model="date_to"
                      :min = "date_from"
                      :events = "interval_dates"
                      :event-color="interval_classes"
                      no-title
                      show-adjacent-months
                      :weekday-format="weekdayFormat"
                      first-day-of-week="1"
                    >
                    </v-date-picker>
                  </v-slide-x-transition>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="date_menu = true">
                    <v-icon>mdi-content-save</v-icon>
                    Выбрать
                  </v-btn>
                </v-card-actions>
              </div>
              
            </v-menu>
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>
    <v-card-text>

      <CheckBox 
        :label="$t('Нерабочие дни')"
        :hint="$t('В указанном диапазоне дней заказы не принимаются')"
        v-model="is_weekend"
      />
      
      <v-divider></v-divider>
      <h3 class="pt-2">Часы работы</h3>
      
      <TimePicker 
        :label="$t('Открытие доставки')"
        :disabled="is_weekend"
        :limit = false
        v-model="time_start"
      />
      <TimePicker 
        :label="$t('Закрытие доставки')"
        :disabled="is_weekend"
        :limit = false
        v-model="time_end"
      />

    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="error" v-if="!is_new" @click="$emit('remove')"><v-icon>mdi-delete</v-icon><T>Удалить</T></v-btn>
      <v-btn text color="primary" @click="()=>{$emit('save'); isRange = true}">
        <v-icon>mdi-content-save</v-icon>
        <T key="1" v-if="is_new">Добавить</T>
        <T key="2" v-else>Сохранить</T>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import CheckBox from '../../common/CheckBox.vue'
import TimePicker from '../../common/TimePicker.vue'

export default {
  props: ['value', 'is_new'],
  data: () => ({
    isRange: false,
    date_menu: null,
    interval_dates: [],
    interval_classes: {}
  }),
  methods: {
    fillLen(str, len) {
      
      while (str.length < len) {
        str = `0${str}`
      }

      return str
    },
    formatDate(date){
      return `${this.fillLen(''+date.getDate(), 2)}.${this.fillLen(''+ (date.getMonth()+1), 2)}.${date.getFullYear()}`
    },
    onDayOfWeek(idx, value) {
      let new_day_of_week = this.value.day_of_week.filter(el => el != idx)

      if (value === true) {
        new_day_of_week.push(idx)
      }

      this.$emit('input', {...this.value,
        day_of_week: new_day_of_week.sort((a,b) => a - b)
      })
      
    },
    weekdayFormat(date_str) {
      let date = new Date(date_str)
      let days = [
        this.$t('вс'),
        this.$t('пн'),
        this.$t('вт'),
        this.$t('ср'),
        this.$t('чт'),
        this.$t('пт'),
        this.$t('сб'),
      ]
      return days[date.getDay()]
    },

    monthFormat(month) {
      return month
    },

    fillDateRange(){
      const start = new Date(this.date_from)
      const end = new Date(this.date_to)
      const startUTC = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate())
      const endUTC = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate())
      const date_diff = Math.abs(Math.floor((startUTC - endUTC)/(1000 * 60 * 60 * 24)))
      
      let classes = {}

      let dates = Array.from({length:date_diff+1}, (_, i)=> {
        let day = 60 * 60 * 24 * 1000;
        let date = new Date(start.getTime() + day*i).toISOString().substr(0, 10)

        const dateClasses = []
        dateClasses.push(`v-date-range_in-range`)
        i === 0 && dateClasses.push('v-date-range_range-start')  
        i === date_diff && dateClasses.push(`v-date-range_range-end`);
        classes[date] = dateClasses.join(" ")
        return date
      })
      
      this.interval_dates = dates
      this.interval_classes = classes
    },

  },
  computed: {
    date_from:{
      set(v){
        if(!this.isRange){
          this.$emit('input',
            {
              ...this.value,
              str_date_start: v,
              str_date_end: v
            }
          )  
        }else{
          this.$emit('input',
            {
              ...this.value,
              str_date_start: v 
            }
          )  
        }
      },
      get(){
        return this.value.str_date_start
      }
    },

    date_to:{
      set(v){
        this.$emit('input',
          {
            ...this.value,
            str_date_end: v
          }
        )
      },
      get(){
        return this.value.str_date_end
      }
    },

    dates_display(){
      let str = ''
      if (this.value.str_date_start) {
        str = this.formatDate(new Date(this.value.str_date_start))
        if (this.value.str_date_end) {
          if (this.value.str_date_start == this.value.str_date_end) {
            return `${str}.`
          } else {
            return `${str} - ${this.formatDate(new Date(this.value.str_date_end))}`
          }
        }
        return `${str}.`
      } else {
        str = this.$t('Укажите диапазон дат')
      }
      return str
    },
    is_weekend: {
      get() {
        return !this.value.is_workday
      },
      set(val) {
        this.$emit('input', {...this.value, 
          is_workday: !val
        })
      }
    },
    tab: {
      get() {
        return this.value.mode == 'DAYOFWEEK' ? 0 : 1
      },
      set(val) {
        if (val == 0) {
          this.$emit('input', {
            ...this.value,
            mode: "DAYOFWEEK",
            // is_workday: true
          })
        } else {
          this.$emit('input', {
            ...this.value,
            mode: "DATERANGE",
            // is_workday: false
          })
        }
      }
    },
    time_start: {
      get() {
        return this.value.str_time_start
      },
      set(v) {
        this.$emit('input', {
            ...this.value,
            str_time_start: v
          })
      }
    },
    time_end: {
      get(){
        return this.value.str_time_end
      },
      set(v){
        this.$emit('input', {
            ...this.value,
            str_time_end: v 
          })
      }
    },
    weekdays() {
      return [
        this.$t('пн'),
        this.$t('вт'),
        this.$t('ср'),
        this.$t('чт'),
        this.$t('пт'),
        this.$t('сб'),
        this.$t('вс'),
      ]
    }
  },
  watch:{
    date_to(val){
      if(val !== undefined && val !== '')
        this.fillDateRange()
      if(val == ''){
        this.interval_dates = []
      }
    },
    date_from(val){
      if(val !== ''){
        this.fillDateRange()
      }  
      if(!this.isRange){
        this.interval_dates = []
      }
    },
    isRange(val){
      if(!val){
        this.interval_dates = []
        this.date_to = this.date_from
      }
    }
  },
  components: {
    CheckBox,
    TimePicker
  }
}
</script>

<style lang="scss">

/* For datepicker */
.date_pickers{
  background: #fff;
  & .v-date-picker-table{
    height: 100%;
    padding: 0;
  }
  & .v-date-picker-table table{
    & td{
      .v-btn {
        position: relative;
        &.v-btn--rounded {
          border: none;
        }
        &.v-btn--active::before {
          background: transparent !important;
        }
        &:has(.v-date-picker-table__events){
          color: #fff !important;
        }
        &:has(.v-date-range_range-end){
          background: transparent !important;
        }
        & .v-date-picker-table__events {
          height: 32px;
          width: 32px;
          top: 0;
          z-index: -1;

          & .v-date-range_in-range {
            position: absolute;
            top: 0;
            left: 0;
            background: var(--v-primary-lighten3);
            height: 100% !important;
            width: 100% !important;
          }

          & .v-date-range_range-end{
            background: var(--v-primary-base);
            // border: 1px solid var(--v-primary-lighten3) !important;
            border-radius: 0% 100% 100% 0% !important;
          }

          & .v-date-range_range-start{
            background: var(--v-primary-base) !important;
            border-radius: 100% 0% 0% 100% !important;
            // border: 1px solid var(--v-primary-lighten3) !important;
            position: relative;
          }

          & div.v-date-range_range-end.v-date-range_range-start{
            border-radius: 100% !important;
          }
        }

      }
    }
  } 
}
</style>